import { isEmpty, forEach } from "lodash";
import { IABTestProvider, ABTestVariation } from "../types";
import { isClient } from "@/utils/browser";
import { getCookie } from "@/services/CookiesService";
import { VWO_COMBINATION_COOKIE_1, VWO_COMBINATION_COOKIE_2 } from "@/internals/constants/cookies";
import { PRICING_3_DAY_CAMPAIGN_ID } from "@/internals/constants/testAB/testAB";

export class VWOProvider implements IABTestProvider {
  private config: any;

  constructor(config?: any) {
    this.config = config;
  }

  initialize(): void {
    // VWO initialization is handled by the script in ThirdPartyScripts
    // This method can be used for additional setup if needed
    if (!isClient()) {
      console.warn("VWO Provider: Cannot initialize on server side");
      return;
    }
  }

  getAssignedVariation(): ABTestVariation | undefined {
    if (!isClient()) return undefined;

    const vwoVariations = (window as any)._vwo_exp;
    if (isEmpty(vwoVariations)) return undefined;

    const variations: ABTestVariation = {};

    forEach(vwoVariations, (variation: any, key: string) => {
      const selectedCombination = Number(variation?.combination_chosen);
      if (!Number.isFinite(selectedCombination) || selectedCombination < 0) return;
      const variationValue = variation.comb_n[Number(selectedCombination)];
      variations[key] = variationValue;
    });
    return variations;
  }

  isReady(): boolean {
    if (!isClient()) return false;

    const vwoVariations = (window as any)._vwo_exp;
    if (isEmpty(vwoVariations)) return false;

    if (
      getCookie(
        `${VWO_COMBINATION_COOKIE_1}${PRICING_3_DAY_CAMPAIGN_ID}${VWO_COMBINATION_COOKIE_2}`
      ) === undefined
    )
      return false;

    return Object.values(vwoVariations).some((variation: any) => {
      const selectedCombination = Number(variation?.combination_chosen);
      return Number.isFinite(selectedCombination) && selectedCombination >= 0;
    });
  }

  getProviderConfig(): any {
    return this.config;
  }

  trackEvent(eventName: string, properties?: Record<string, any>): void {
    if (!isClient()) return;

    // VWO event tracking implementation
    if ((window as any).VWO && (window as any).VWO.event) {
      (window as any).VWO.event(eventName, properties);
    }
  }
}
